import { Chip } from '@mui/material';
import type { RelationshipState } from './relationshipApi.ts';

const stateChips: Record<
  RelationshipState,
  { label: string; color: 'success' | 'info' | 'warning' | 'default' }
> = {
  WARM: { label: 'Warm', color: 'success' },
  ACTIVE: { label: 'Active', color: 'info' },
  COOLING: { label: 'Cooling', color: 'warning' },
  COLD: { label: 'Cold', color: 'default' }
};

export const RelationshipStateChip = ({ state }: { state: RelationshipState }) => {
  const chip = stateChips[state] ?? { label: state, color: 'default' };
  return <Chip size="small" label={chip.label} color={chip.color} />;
};
